import { NavLink } from "react-router-dom";

import { styled } from "@mui/material/styles";

import { misc } from "app/themes/colors";

/** The bold 14px title link of a MESSAGE bell row, shared by its plain and "not delivered" forms. */
const MessageNotificationLink = styled(NavLink)(() => ({
  "&": {
    color: misc.blackAsphalt,
    fontSize: 14,
    fontWeight: 700,
    mb: 0.5
  },
  "&:hover": {
    cursor: "pointer",
    color: misc.linkColor
  },

  "&.active": {}
}));

export default MessageNotificationLink;
